import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter,useParams } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page/Page';
import {  LiveFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";
import { useHistory } from 'react-router-dom';

import { Header, Results,AddPrice } from './components';
import { it } from 'date-fns/locale';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const EditStoreprice = withRouter(props => {
  
  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const [isadd, setIsadd] = useState(false);
  const [liveobj, setLiveobj] = useState({});
  const [totalCount, setTotalcount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const snackbarCtx = React.useContext(SnackBarContext);
  const [viewtype, setViewtype] = useState('1');
  const [rateid, setRateid] = useState('');
  const [isworking, setIsworking] = useState(false);
  const history = useHistory();
  const [prevprices, setPrevprices] = useState({});
  const [wholeorders, setWholeorders] = useState([]);

  useEffect(() => {

    //fetchallprices()
  //  setOrders([{
  //   product: {
  //     productname : "TUTICORIN PORT PALMOLEIN OIL"

  //   },
  //   rangestart : 1000,
  //   rangeend : 1500,
  //   price_diff : '-500'
  //  }])
  }, [rowsPerPage,page]);

  useEffect(() => {
    let params_arr = props.location.pathname.split('/');
    var rate_id = '';
    var view_type = '';
    if(params_arr.length > 2)
    {
       rate_id = params_arr[2];
       setRateid(rate_id)
    }
    if(params_arr.length > 2)
    {
       view_type = params_arr[3];
       setViewtype(view_type)
    }
  //  updaterates(rate_id)
    fetchallprices(rate_id,view_type)
  //fetchallprices(rate_id)
  
  }, []);
  function calculatedifference(currentobj,prevobject){
    if(currentobj.price_start <= 0 || prevobject?.price_start <= 0 )
    {
     return 0

    }else
    {
      return currentobj.price_start - prevobject?.price_start
    }
  }
  async function updateprice(liveobj)
  {
  
    let newprices = [];
    let newobj = {};

    // prevprices.map((itm) => {
    //   if (itm?.id == liveobj?.id) {
        newobj = {
          ...prevprices[liveobj?.id],
          ...liveobj,
          price_difference: calculatedifference(liveobj, prevprices[liveobj?.id]),
        };
        newprices.push(newobj);
    //   }
    // });

    orders.map((itm) => {
      if (itm?.id != liveobj?.id) {
        newprices.push({ ...itm });
      }
    });
    setOrders([...newprices]);
    setIsadd(false);
    /*
    let url = '/admin/updatestoreproductprice';
    
     let adminusers = await sendNetworkRequest(url, {}, {...liveobj,viewtype},false)
     setIsadd(false)
    // snackbarCtx.setSnack({
    //   ...snackbarCtx,
    //   open: true,
    //   type: adminusers.status,
    //   msg: adminusers.message,
    //   vertical: "top",
    // });
    fetchallprices(rateid)*/
  }
  function onLocalsearch(searchtxt)
  {
    
    var filterobj = wholeorders.filter(function (entry) {
      let price_start = "";
      let price_end = "";
      
      // if(entry.store_prices?.length > 0)
      // {
      //   let price_obj = entry.store_prices[0]

      //   price_start = price_obj?.price_start +'';
      //   price_end = price_obj?.price_end + "";

      // }
      return entry?.master_store_product?.name.toLowerCase().indexOf(searchtxt.toLowerCase()) > -1;
  });
  setPage(0)
  setOrders([...filterobj])

}

  function onPagelimitchange(pagelimit)
  {
    setRowsPerPage(pagelimit)

  }
  function onPagechange(page)
  {
    setPage(page)

  }
  async function dismiss()
  {

    setIsadd(false)
  }
  function addprice(priceobj){
    
     setIsworking(true) 

    let liveprice_history = {}
      if(priceobj && priceobj.store_prices && priceobj.store_prices.length > 0){
        liveprice_history = {
          ...priceobj.store_prices[0]
        }
      }
      
      // setLiveobj({
      //       product_id : priceobj.product_id,
      //       broker_id : priceobj.broker_id,
      //       broker_product_id : priceobj.id,
      //       name : priceobj?.master_store_product?.name,
      //       price_start : liveprice_history?.price_start,
      //       price_end : liveprice_history?.price_end,
      //       isRange : liveprice_history?.price_end > 0 ? true : false
      // })


      setLiveobj({...priceobj
  })
 
   setIsadd(true)
  }

  async function deleteprice(priceobj){
  if(priceobj.live_prices && priceobj.live_prices.length > 0)
  {
  let bodyparams = {
    product_id : priceobj.id,
    live_price_id : priceobj.live_prices[0].id
  }
  let adminusers = await sendNetworkRequest('/admin/deletestorepricehistory', {}, bodyparams,false)
  // snackbarCtx.setSnack({
  //   ...snackbarCtx,
  //   open: true,
  //   type: adminusers.status,
  //   msg: adminusers.message,
  //   vertical: "top",
  // });
   fetchallprices()
} 
}
  function editprice(priceobj)
  {
    setIsworking(true) 
    let liveprice_history = {}
    if(priceobj && priceobj.store_prices && priceobj.store_prices.length > 0)
    {
      liveprice_history = {
        ...priceobj.store_prices[0]
      }
    }
    setLiveobj({
          live_price_id: liveprice_history.id,
          product_id: priceobj.product_id,
          broker_id : priceobj.broker_id,
          broker_product_id : priceobj.id,
          name: priceobj?.master_store_product?.name,
          price_start: liveprice_history.price_start,
          price_end: liveprice_history.price_end,
          price_difference: liveprice_history.price_difference,
          isRange: liveprice_history.price_end > 0 ? true : false
    })
    setIsadd(true)
  }
  function onSearch(key, value)
  {
    fetchallprices(value)
  }
  async function fetchallprices(value,viewval)
  {
    
    let bodycontent = {
      offset : page * rowsPerPage,
      limit : rowsPerPage
    }
    if(value)
    {
      bodycontent = {
        ...bodycontent,
        "searchtext" : value
      }
    }

    
    let adminusers = await sendNetworkRequest('/admin/getbrokerproducts', {}, {broker_id : value},true)
   
    let prevprice_arr = {}
   
     if(adminusers  && adminusers?.module)
    {
    adminusers.module.map((element) => {
      prevprice_arr[element?.id] = {
        product_id : element.product_id,
        broker_id : element.broker_id,
        broker_product_id : element.id,
        price_start : element?.price_start,
        price_end : element?.price_end,
       }
    })
    }
    if(viewval == 2)
    {
      let oldprice = await sendNetworkRequest('/admin/fetcholdprice', {}, {broker_id : value},true)
        if(oldprice  && oldprice?.data)
        {
          oldprice.data.map((element) => {
          prevprice_arr[element?.id] = {
            product_id : element.product_id,
            broker_id : element.broker_id,
            broker_product_id : element.id,
            price_start : element?.price_start,
            price_end : element?.price_end,
           }
        })
        }
    }

    setPrevprices(prevprice_arr)
    setOrders(adminusers?.module)
    setWholeorders(adminusers?.module)

    setTotalcount(adminusers?.module?.length??0)
    
  }
  async function createrateline()
  {
    setIsworking(false)
    let product_prices = []

    let bodycontent = {
      broker_id : rateid,
      isupdate: viewtype

    }
    orders.map(itm => {
      product_prices.push({
        id : itm?.id,
        broker_id : itm?.broker_id,
        product_id : itm?.product_id,
        price_start : itm?.price_start,
        price_end : itm?.price_end,
        price_difference : calculatedifference(itm, prevprices[itm?.id])

      })
    })
    bodycontent['prices'] = product_prices
   let response_obj = await sendNetworkRequest('/admin/updatebrokerprice', {}, bodycontent,false)
 //  fetchallprices(rateid)
  snackbarCtx.setSnack({
    ...snackbarCtx,
    open: true,
    type: "success",
    msg: response_obj?.message,
    vertical: "top",
  });
  
  history.push("/managerates");
  }
  async function cancelrateline()
  {
   
    // setIsworking(false)
    // let bodycontent = {
    //   broker_id : rateid,
    //   isupdate: 3

    // }
    // let response_obj = await sendNetworkRequest('/admin/updatebrokerprice', {}, bodycontent,false)
    // fetchallprices(rateid)
    history.push("/managerates");
  // console.log(JSON.stringify(orders[0]))
 

  }
  async function updaterates(rate_id)
  {
   
    
    let bodycontent = {
      broker_id : rate_id,
      isupdate: 3

    }
    let response_obj = await sendNetworkRequest('/admin/updatebrokerprice', {}, bodycontent,false)
    fetchallprices(rate_id)
  // console.log(JSON.stringify(orders[0]))
  
  }
  return (
    <Page
      className={classes.root}
      title="Live Prices"
    >
      <Header broker={orders.length > 0 ? orders[0].master_broker : ""}/>
      {isadd ? <AddPrice onUpdate={updateprice}  onDismiss={dismiss} liveobj={liveobj}/> : null }

       {/* <LiveFilter onSearch={onSearch}/>  */}
      <Results
        isworking={isworking}
        className={classes.results}
        onLocalsearch={onLocalsearch}
        orders={orders} //
        totalCount={totalCount}
        onAdd={addprice}
        onEdit={editprice}
        onDelete={deleteprice}
        page={page}
        onPagechange={onPagechange}
        onPagelimitchange={onPagelimitchange}
        rowsPerPage={rowsPerPage}
        onSave={createrateline}
        onCancel={cancelrateline}
      />
     
    </Page>
  );
});

export default EditStoreprice;
